import React, { useEffect, useRef, useState } from "react";
import "./InputSelect.scss";
import { useClickOutside } from "use-events";
import { FaAngleDown } from "react-icons/fa6";

const InputSelect = ({
  name,
  required,
  register,
  value,
  handleChange,
  options,
  reset,
  isForm,
  label,
  inputErrors,
  isMulti,
  disabled,
  ...rest
}) => {
  const selectRef = useRef(null);

  const [openOption, setOpenOption] = useState(false);
  const [labelActive, setLabelActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    isMulti ? [] : { label: "", value: "" }
  );

  useClickOutside([selectRef], () => {
    setOpenOption(false);
    if ((isMulti && selectedValue?.length > 0) || value?.value !== "") {
      setLabelActive(true);
    } else {
      setLabelActive(false);
    }
  });

  const handleOptionClick = (data) => {
    if (isMulti) {
      const alreadySelected = selectedValue.find(
        (item) => item.value === data.value
      );
      const newSelectedValue = alreadySelected
        ? selectedValue.filter((item) => item.value !== data.value)
        : [...selectedValue, data];

      setSelectedValue(newSelectedValue);
      handleChange(newSelectedValue);
      reset({ [name]: [...newSelectedValue.map((item) => item.value)] });
    } else {
      setSelectedValue(data);
      handleChange(data);
      reset({ [name]: data.value });
      setOpenOption(false);
    }
  };

  useEffect(() => {
    if (!isMulti) {
      if ((value?.value !== "" || !value?.value) && required) {
        register(name, { required: false });
      } else {
        register(name, { required: required });
      }
      setSelectedValue(value);
    }

    if (isMulti && value?.length > 0) {
      setSelectedValue(value);
      if (required) {
        register(name, { required: false });
      }
    } else {
      if (isMulti) {
        setSelectedValue([]);
      }
      register(name, { required: required });
    }
  }, [value]);

  useEffect(() => {
    let hasValue = false;
    if (
      (isMulti && selectedValue?.length > 0) ||
      (selectedValue?.value !== null &&
        selectedValue?.value !== undefined &&
        selectedValue?.value !== "")
    ) {
      hasValue = true;
    }

    setLabelActive(hasValue);
  }, [selectedValue, isMulti]);

  return (
    <div className="custom-input-select" ref={selectRef}>
      <label htmlFor={name} className={`label ${labelActive ? "active" : ""}`}>
        {label}
      </label>
      <div
        className={`showSelected ${disabled ? "disabled" : ""}`}
        onClick={() => {
          !disabled && setOpenOption(!openOption);
        }}
      >
        {isMulti
          ? selectedValue?.length
            ? selectedValue?.map((item) => item?.label).join(", ")
            : ""
          : selectedValue?.label}
      </div>
      <div className={`options ${openOption ? "open" : ""}`}>
        {/* {isForm && (
          <div
            className={`option ${selectedValue.length === 0 ? "active" : ""}`}
            onClick={() => handleOptionClick({ label: "Select", value: "" })}
          >
            Select
          </div>
        )} */}
        {options?.map((opt, i) => (
          <div
            className={`option ${
              isMulti
                ? selectedValue.find((item) => item?.value === opt?.value)
                  ? "active"
                  : ""
                : opt?.value === selectedValue?.value
                ? "active"
                : ""
            } ${opt?.isButton ? "option-btn" : ""}`}
            key={i}
            onClick={() => {
              if (opt?.isButton) {
                opt?.handleClick && opt?.handleClick();
              } else {
                handleOptionClick(opt);
              }
            }}
          >
            {opt?.label}
          </div>
        ))}
      </div>
      <div className={`select-icon ${openOption ? "open" : ""}`}>
        <FaAngleDown />
      </div>
      {inputErrors[name]?.type && (
        <p className="error">
          {inputErrors[name]?.type === "required"
            ? `${label} field is required.`
            : `${label} input is not valid.`}
        </p>
      )}
    </div>
  );
};

export default InputSelect;
